<template>
  <icon-new-message v-if="type === 10" />
  <icon-new-permit v-else-if="type === 20 || type === 21" />
  <icon-permit-expires v-else-if="type === 1000" />
  <icon-action-date-without-assistance v-else-if="type === 1001" />
  <icon-permit-without-update v-else-if="type === 1002" />
  <icon-permit-date v-else-if="type === 22 || type === 23" />
  <icon-document-upload v-else-if="type === 25 || type === 31|| type === 40|| type === 50" />
  <icon-questionnaire v-else-if="type === 26 || type === 30 || type === 41" />
  <icon-user-add-v2 v-else-if="type === 27" />
  <icon-document-status v-else-if="type === 24 || type === 28" />
  <icon-permit-obtained v-else-if="type === 29" />
  <icon-notification v-else />
</template>

<script>
export default {
  name: 'NotificationTypeIcon',
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
};
</script>
